<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .dialler-container {
    left: utils.in_rem(40px);
    position: fixed;
    top: utils.in_rem(40px);
    z-index: 1050;
  }

  .dialler-window {
    width: utils.in_rem(268px);
    height: utils.in_rem(521px);
    background: linear-gradient(180deg, #253e6d 0%, #131f37 105.12%);
    border-radius: utils.in_rem(16px);
    box-shadow: 0 0 utils.in_rem(16px) rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    font-family: "Lato", sans-serif;
    overflow: hidden;

    &.dragging {
      cursor: grabbing;
      user-select: none;
    }

    .dialler-main {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
    }
  }
</style>

<script>
  import { onMount } from "svelte";
  import DiallerBody from "./components/DiallerBody.svelte";
  import { diallerState } from "./diallerState.svelte";
  import { cleanupDiallerStores } from "./stores";
  import { draggable } from "./utils/draggable";
  import { loadDiallerData } from "./utils/initialization";

  export const openDialler = (params = {}) => diallerState.openDialler(params);

  const open = $derived(diallerState.isOpen);

  let windowElement = $state();
  let isDragging = $state(false);

  onMount(() => {
    loadDiallerData();
  });

  const handleClose = async () => {
    // Only allow closing if there's no active call AND outcome modal is not showing
    if (!diallerState.activeCall && diallerState.viewMode !== "outcome") {
      diallerState.closeDialler();
      try {
        await cleanupDiallerStores();
      } catch {
        console.error("Failed to cleanup dialler stores");
      }
    }
  };

  const handleKeydown = (e) => {
    if (e.key === "Escape" && open) {
      handleClose();
    }
  };
</script>

<svelte:window onkeydown={handleKeydown} />

{#if open}
  <div
    class="dialler-container"
    use:draggable={{
      handle: windowElement,
      bounds: "viewport",
      initialPosition: { x: 40, y: 40 },
      onDragStart: () => (isDragging = true),
      onDragEnd: () => (isDragging = false),
    }}
  >
    <div
      bind:this={windowElement}
      class="dialler-window"
      class:dragging={isDragging}
      role="dialog"
      aria-modal="true"
      aria-label="Dialer"
    >
      <main class="dialler-main">
        <DiallerBody />
      </main>
    </div>
  </div>
{/if}
